import { useEffect, useRef } from 'react'

import { notifyParent, storeGet } from 'mailup-react-helpers'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_USER,
  STORE_KEY_ID_LIST
} from 'mailup-react-helpers'

const useSessionCheck = () => {
  const timer = useRef(null)
  const { current: ignorePath } = useRef(['/', '/auth', '/noauth'])

  const checkSession = () => {
    const pathname = window.location.pathname.match(/\/(\d+)(\/.*)$/)[2]

    if (!ignorePath.includes(pathname)) {
      const { Id: consoleId } = storeGet(STORE_KEY_ACCOUNT) || ''
      const { Id: userId } = storeGet(STORE_KEY_USER) || ''
      const listId = storeGet(STORE_KEY_ID_LIST) || ''

      notifyParent('checkAppSession', [
        { consoleId, userId, listId },
        'messages_app_redirector.aspx?r=/messages/email/saved'
      ])
    }
  }

  useEffect(() => {
    timer.current = setInterval(checkSession, 5000)

    return () => {
      clearInterval(timer.current)
    }
  }, [])
}

export default useSessionCheck
